import { SITE_TIME_ZONE } from "@/app/booking-calendar/lib/siteTime"
import type { BookingSeasonSnapshot } from "./bookingSeasonApi"

// Shared by the Booking Season page and the staff calendar, so the two can never describe the same
// season differently. Always Pacific, whatever zone the browser is in: the season is set in Pacific
// time and every site is there.

const dateTimeFormat = new Intl.DateTimeFormat("en-US", {
  timeZone: SITE_TIME_ZONE,
  dateStyle: "medium",
  timeStyle: "short",
})

/** "Oct 1, 2026, 12:00 AM PT" for an ISO instant. */
export function formatSeasonDateTime(iso: string): string {
  return `${dateTimeFormat.format(new Date(iso))} PT`
}

/**
 * The staff-facing reason a season is closed: "No season set", "Opens {date time}",
 * "Ended {date time}" or, with every booking program off (SHEAP does not count), "Every booking program is switched off".
 * Null while the season is open.
 */
export function closedReasonLabel(season: BookingSeasonSnapshot): string | null {
  switch (season.closedReason) {
    case null:
      return null
    case "NotConfigured":
      return "No season set"
    case "NotYetOpen":
      return season.opensAt ? `Opens ${formatSeasonDateTime(season.opensAt)}` : "Not yet open"
    case "Ended":
      return season.closesAt ? `Ended ${formatSeasonDateTime(season.closesAt)}` : "Ended"
    case "AllProgramsDisabled":
      return "Every booking program is switched off"
  }
}
